import { render, staticRenderFns } from "./ModalNewTable.vue?vue&type=template&id=32aee338&"
import script from "./ModalNewTable.vue?vue&type=script&lang=js&"
export * from "./ModalNewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports